// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bzur","col":"styles_col__3Qlie"};